
// 导入图片文件
import viewWhite from '../assetsV2/featured/view_white.png';
import likeWhite from '../assetsV2/featured/like_white.png';
import likeIconSvg from '../assetsV2/featured/like-icon.svg';
import viewIconSvg from '../assetsV2/featured/view-icon.svg';

// 新增默认导出
const featuredAssets = [
  viewWhite,
  likeWhite,
  likeIconSvg,
  viewIconSvg
];

export default featuredAssets;
